import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';

import stakingReducer from './staking';
import govTokenReducer from './govToken';
import governorReducer from './governor';
import proposalReducer from './proposal';

const store = configureStore({
    reducer: {
        staking: stakingReducer,
        govToken: govTokenReducer,
        governor: governorReducer,
        proposal: proposalReducer
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    }),
});

export default store;